export const HEADER_STYLE = "opcion4-moderno-editorial";
